// extracted by mini-css-extract-plugin
export default {"wrapper":"records_wrapper__QmrGM"};